module.exports = __webpack_public_path__ + "fonts/butler_black-webfont.4a9ffe5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/butler/butler_black-webfont.woff2
// module id = 553
// module chunks = 0